module.exports = __webpack_public_path__ + "images/emoji/skull.6487feaeefce5dcd15ba.png";